import React from 'react';
import Icon from '../../../components/AppIcon';


const PlayerCard = ({ player, onAction, actionIcon, actionLabel }) => {
  const getRoleIcon = (role) => {
    const roleMap = {
      'Batter': 'Target',
      'Bowler': 'Zap',
      'Wicket Keeper': 'Shield',
      'All-rounder': 'Star'
    };
    return roleMap?.[role] || 'User';
  };

  const getRoleBadgeColor = (role) => {
    const colorMap = {
      'Batter': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
      'Bowler': 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
      'Wicket Keeper': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
      'All-rounder': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
    };
    return colorMap?.[role] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="flex items-center justify-between p-3 border border-border rounded-lg hover:bg-muted/30 transition-colors">
      <div className="flex items-center gap-3 flex-1">
        <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center">
          <Icon name={getRoleIcon(player?.role)} className="w-5 h-5 text-muted-foreground" />
        </div>
        <div className="flex-1">
          <p className="font-medium text-foreground">{player?.name}</p>
          <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full mt-1 ${getRoleBadgeColor(player?.role)}`}>
            {player?.role}
          </span>
        </div>
      </div>
      <button
        onClick={onAction}
        className="p-2 hover:bg-muted rounded-lg transition-colors"
        title={actionLabel}>
        <Icon name={actionIcon} className="w-4 h-4 text-muted-foreground" />
      </button>
    </div>
  );
};

export default PlayerCard;